/* eslint-disable import/no-duplicates */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
/* eslint-disable @stylistic/max-len */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable camelcase */
/* eslint-disable react/destructuring-assignment */
import React, { useState, useEffect, useCallback } from "react";
import jsPDF from "jspdf";
import { applyPlugin } from "jspdf-autotable";
import { Container, Col, Row } from "react-bootstrap";
import Popup from "reactjs-popup";
import * as Sentry from "@sentry/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useSearchParams } from "react-router-dom";

import { debounce } from "lodash";
import QuoteHistoryModal from "../Modals/QuoteHistory";
import FabricAllowedModalIndoor from "../Modals/FabricAllowedIndoor";
import FabricAllowedModalOutdoor from "../Modals/FabricAllowedOutdoor";
import PopulateDashboardTasks from "../Modals/QuotePopulateDashboardTasks";
import CostBreakownModal from "../Modals/QuoteCostBreakdown";
import ConfirmApproval from "../Modals/ConfirmApproval";
import QuoteLockedModal from "../Modals/QuoteLocked";

import TextArea from "../Parts/TextArea";
import PlaceOrder from "./OrderModal/PlaceOrder";
import ProductForm from "./NewOptionFields/ShadeActions/ProductForm";

import ForceEditModal from "./ForceEditModal";

import QuoteFields from "./QuoteFields";
import AddPSOutdoorShadeModel from "./AddPSOutdoorShadeModal";
import QuoteActionsNew from "./NewItems/QuoteActions";
import InvoiceTable from "./InvoiceTable";
import TotalPrice from "./TotalPrice";

import ShadeCostBreakdown from "./ShadeCostBreakdown";

import QuoteVerifications from "./NewItems/QuoteVerification";
import { UsePortalDispatch } from "../Store";
import Button from "../Parts/Button";

import { useIndoorFabrics, usePSOutdoorFabrics } from "../Store/entities/hooks";
import { RefreshQuotePricing, updateQuoteNotes, wentToQuote } from "../Store/entities/quotes";
import { useIsQuoteLoaded, UseMultipliersByQuoteId, useQuoteById, useQuoteIdAndDispatch, useQuoteLoadFailed, useQuoteTitle, useQuoteTypeNameByQuoteId, useClearQuoteOnNavigate } from "../Store/entities/quotes/hooks";
import { UseUnAcknowledgedWarnings } from "./NewItems/QuoteWarningVerificationsFromStore";
import { loadQuoteAssemblies } from "../Store/entities/assemblies";
import { GetAssemblyOptions } from "../Store/entities/assemblyOptions";
import AddCOROutdoorShadeModal from "../Modals/ShadeModals/AddShade/AddCOROutdoorShade";
import { useIsPsAdmin } from "../hooks";
import type { fakeRootType } from "../FakeRootType";
import QuotePopulateDashboardTasks from "../Modals/QuotePopulateDashboardTasks";
import QuoteAdminBar from "./QuoteAdminBar";
import QuoteReviewTable from "../Modals/QuoteProjectedReviews";

applyPlugin(jsPDF);

// import { useIsLoggedIn, useIsPsAdmin, useIsManufacturer, useIsDealer } from 'hooks';

type QuoteProps = {
	ROOT: fakeRootType;
	setTitle: (title: string) => void;
	loading: () => void;
};

const Quote = (props: QuoteProps) => {
	const [showingPlaceOrder, setShowingPlaceOrder] = useState(false);
	const [showingApproveModal, setShowingApproveModal] = useState(false);
	const [showProductForm, setShowProductForm] = useState(false);
	const [showForceEditModal, setShowForceEditModal] = useState(false);
	const [quoteLockedUser, setQuoteLockedUser] = useState(null);
	const [showingHistoryModal, setShowingHistoryModal] = useState(false);
	const [ShowingFabricAllowedIndoorModal, setShowingFabricAllowedIndoorModal] = useState(false);
	const [ShowingFabricAllowedOutdoorModal, setShowingFabricAllowedOutdoorModal] = useState(false);
	const [showingPopulateDashboardTasks, setShowingPopulateDashboardTasks] = useState(false);
	const [showingPopulateDashboardModal, setShowingPopulateDashboardModal] = useState(false);
	const [showingCostBreakdown, setShowingCostBreakdown] = useState(false);
	const [showingQuoteReviews, setShowingQuoteReviews] = useState(false);
	const [showEditQuoteDisclaimer, setShowEditQuoteDisclaimer] = useState(-1); // Allows for sequenceId of 0
	const [costBreakdownShade, setCostBreakdownShade] = useState(null);
	const [showConfigurations, setShowConfigurations] = useState(false);
	// const [currentDealer, setCurrentDealer] = useState<null|DealerStore>(null);
	// [renderCount, setRenderCount] = useState(0),
	// const [demoReviewFailed, setDemoReviewFailed] = useState(false);
	const [showAddPSOutdoorShade, setShowAddPSOutdoorShade] = useState(false);
	const [showAddCOROutdoorShade, setShowAddCOROutdoorShade] = useState(false);

	const [searchParams] = useSearchParams();
	const quoteID = Number(searchParams.get("quoteID"));

	useClearQuoteOnNavigate(quoteID);

	const quoteStore = useQuoteIdAndDispatch(quoteID);

	const isEditable = quoteStore?.editable ?? false;

	const changeNotes = useCallback(debounce((new_value) => {
		dispatch(updateQuoteNotes({
			quoteId: quoteID,
			notes: new_value
		}));
	}, 500), [quoteID, quoteStore?.notes]);

	const quoteTitle = useQuoteTitle(quoteID);
	const multipliers = UseMultipliersByQuoteId(quoteID)?.list ?? [];

	const isLoaded = useIsQuoteLoaded(quoteID);
	const loadFailed = useQuoteLoadFailed(quoteID);

	useEffect(() => {
		if (!isLoaded && !loadFailed) {
			props.ROOT.loading();
		} else {
			props.ROOT.loaded();
		}
	}, [isLoaded, loadFailed]);

	useEffect(() => {
		if (multipliers.length > 0) props.setTitle(quoteTitle);
	}, [quoteTitle, multipliers]);

	useEffect(() => {
		dispatch(GetAssemblyOptions(quoteID));
	}, []);

	const dispatch = UsePortalDispatch();

	const indoorFabrics = useIndoorFabrics(quoteID);
	// console.log('🔹🔹🔹🔹🔹🔹 Content', quoteID);
	const psOutdoorFabrics = usePSOutdoorFabrics(quoteID);

	const isPsAdmin = useIsPsAdmin();
	// let isDealer = useIsDealer();

	// const lockAllShades = () => { };
	const quoteWarnings = UseUnAcknowledgedWarnings(quoteID);
	const needsVerification = quoteStore?.order_status === 'active_quote' && quoteWarnings.length > 0;

	const { editable } = quoteStore ?? { editable: false };
	// const setEditable = (editableNow) => {
	// 	editableNow ? dispatch(setQuoteToEditable(quoteID)) : dispatch(setQuoteToUnEditable(quoteID));

	// };

	// function useForceUpdate(){
	// 	let getMe = renderCountGet;

	// 	return () => setRenderCount(getMe() + 1); // update the state to force render
	// };

	// const hasValidPropertyAddress = quoteStore ? useHasValidPropertyAddress(quoteStore) : false;

	const { ROOT } = props;

	// function showPlaceOrder() {
	// 	// const has_signature_series_fabric = quote.shades.some(
	// 	// 	(s) =>
	// 	// 		s.val("fabric_name").toLowerCase().includes("signature")
	// 	// 		|| s.val("fabric2_name").toLowerCase().includes("signature")
	// 	// );

	// 	const isMotorized = (shade) =>
	// 		shade.getOption("shade_type").value === "motorized";

	// 	// const getMotorAndTube = function (shade) {
	// 	// 	const tube = shade.getOption("tube_sku").value;

	// 	// 	const motor = shade.getOption("motor_type").value;

	// 	// 	return [motor, tube];
	// 	// };

	// 	// const hasDifferentSpeeds = ((quote) => {
	// 	// 	let outerMotor = null;
	// 	// 	let outerTube = null;

	// 	// 	const shadesToCheck = quote.shades.filter(
	// 	// 		(s) => s.getOption("indoor_outdoor").value === "indoor"
	// 	// 	);

	// 	// 	for (const shadeIndex in shadesToCheck) {
	// 	// 		const shade = quote.shades[shadeIndex];

	// 	// 		if (!isMotorized(shade)) continue;

	// 	// 		const [motor, tube] = getMotorAndTube(shade);

	// 	// 		outerMotor = outerMotor === null ? motor : outerMotor;
	// 	// 		outerTube = outerTube === null ? tube : outerTube;

	// 	// 		if (outerMotor !== motor || outerTube !== tube) {
	// 	// 			return true;
	// 	// 		}
	// 	// 	}

	// 	// 	return false;
	// 	// })(quoteStore);

	// 	// Put a put false in here to disable until we want to activate it.

	// 	setShowingPlaceOrder(true);
	// }

	// const quotePricing = useQuotePricing(quoteID);

	// const fabricSamples = useQuoteFabricSamplesByQuoteId(quoteID);
	// const fabricSampleCount = fabricSamples.reduce((total, fa) => fa.Quantity + total, 0)

	// const errors = useErrorsByQuoteId(quoteID);

	// async function attemptPlaceOrder() {
	// 	const has_missing_msrps = quotePricing?.assembly_pricing
	// 		.some((sa) => sa.price < 1);

	// 	const has_shade_errors = errors.length > 0;

	// 	const hasShadeError = has_missing_msrps || (has_shade_errors && quoteStore.order_status !== "active_quote");

	// 	if (hasShadeError) {
	// 		ROOT.alert({
	// 			icon: "error",
	// 			text: "Please click Edit Quote and address all shade errors before placing an order.",
	// 			title: "Shade Errors",
	// 			quickFormat: "error"
	// 		})
	// 			.then(() => { })
	// 			.catch(() => { });
	// 	} else if (!hasValidPropertyAddress) {
	// 		ROOT.alert({
	// 			icon: "error",
	// 			text: "Please enter a valid property address before placing an order.",
	// 			title: "Missing Property Address",
	// 			quickFormat: "error"

	// 		})
	// 			.then(() => { })
	// 			.catch(() => { });
	// 	} else if (fabricSampleCount > MAX_SAMPLE_QUANTITY) {
	// 		ROOT.alert({
	// 			text:
	// 				`Please limit fabric samples order quantity to ${MAX_SAMPLE_QUANTITY
	// 				} or less.`,
	// 			title: "Fabric Samples Limit",
	// 			oneButton: true,
	// 			icon: "warning"

	// 		})
	// 			.then(() => { })
	// 			.catch(() => { });
	// 	} else {
	// 		const property_name = quoteStore?.property_address?.company_name ?? "";

	// 		const { address_snapshot } = (
	// 			await apiCalls.getQuoteAddressSnapshot(property_name, quoteStore?.dealer_id ?? 0)
	// 		).data;

	// 		if (address_snapshot !== null) {
	// 			ROOT.alert({
	// 				title: "Existing Property Name",
	// 				icon: "warning",
	// 				text: isDealer ? (
	// 					<span>
	// 						There is already an installation address with the property
	// 						name "
	// 						{property_name}
	// 						".
	// 						<br />
	// 						<br />
	// 						Continuing with this property name will add shades to the
	// 						existing property in the dashboard.
	// 						<span
	// 							style={{ display: "block", marginBottom: "10px" }}
	// 						/>
	// 					</span>
	// 				) : (
	// 					<span>
	// 						There is already an installation address with the property
	// 						name "
	// 						{property_name}
	// 						" for this dealer.
	// 						<br />
	// 						<br />
	// 						Continuing with this property name will add shades to the
	// 						existing property in the dashboard.
	// 						<span
	// 							style={{ display: "block", marginBottom: "10px" }}
	// 						/>
	// 					</span>
	// 				),
	// 				cancelButtonText: "Edit Property Name",
	// 				acceptButtonText: "Continue",
	// 				quoteType
	// 			})
	// 				.then(showPlaceOrder)
	// 				.catch(() => setShowingPropertyAddressEditor(true));
	// 		} else {
	// 			showPlaceOrder();
	// 		}
	// 	}
	// }

	// /**
	//  * Waits until a certain status check is true or until a maximum number of checks is reached.
	//  * @param {function} statusCheck - A function that returns a boolean indicating
	//  * whether the desired status has been reached.
	//  * @param {string} errorMsg - An error message to be thrown if the
	//  * maximum number of checks is reached before the desired status is reached.
	//  * @returns {Promise} - A promise that resolves when the desired
	//  * status is reached or rejects with an error message if the maximum number of checks is reached.
	//  * @notes Max checks is set to 15 - so max amount of waiting will be 15 seconds.
	//  */
	// const waitUntilLoadStatus = (statusCheck, errorMsg) => new Promise((resolve, reject) => {
	// 	let checkCount = 0;
	// 	const maxChecks = 15;

	// 	const checkInterval = setInterval(() => {
	// 		const status = statusCheck();
	// 		if (status) {
	// 			clearInterval(checkInterval);
	// 			resolve();
	// 		} else if (++checkCount >= maxChecks) {
	// 			clearInterval(checkInterval);
	// 			reject(new Error(errorMsg));
	// 		}
	// 	}, 1000); // check every second
	// });

	const loadQuoteWithID = async () => {
		const load_quote_id = quoteID;

		props.loading();
		dispatch(wentToQuote(load_quote_id));
		dispatch(RefreshQuotePricing({ quoteId: load_quote_id }));
		dispatch(loadQuoteAssemblies({
			quoteId: load_quote_id,
			isAdd: false
		})).then(() => {
			// setQuoteLoaded(true);
		});
		Sentry.setTag("Quote ID", load_quote_id);

		// Ensure Demo Data Loaded
		/*
if (resp.data.Quote.quote_type_id === 6) {
						api.getDemoReview(load_quote_id).then((resp) => {
							if (resp.status !== 200 || !resp?.data || !resp?.data?.demoReviews) {
								// ! If this call fails the quote can still be loaded and edited,
								// ! but the demo will not be placeable.
								setDemoReviewFailed(true);
								throw new Error('Something went wrong retrieving demo review');
							}

							const { data } = resp;

							const demoReview = data.demoReviews
								? data.demoReviews.find((d) => true)
								: null;

							newQuote.SetDemoInfo(demoReview);
						});
					}

		*/

		// Ensure Order Shipments and Status correct
		/*

api.getOrderStatus(load_quote_id).then((resp) => {
						if (isFailedApiCall(resp)) throw resp.error;
						const { quote_status } = resp.data;

						newQuote.loadShippingStatus(quote_status);
						newQuote.setROOT(ROOT);
						newQuote.checkExpiration();
						newQuote.rerender();

						setTimeout(() => {
							newQuote.checkExpiration();
						}, 2000);
					}).catch((err) => {
						console.error({ err });
						throw new Error('Something went wrong retrieving order status. Please check the console for more details.');
					});
		*/

		// Ensure Quote Currency is Correct
		/*

api.currencyData().then((data) => {
				setCurrencyData(data);
			});
		*/
	};

	// const keydownHandler = (e) => {
	// 	if ((e.key === 'r' || e.key === 'R') && e.ctrlKey && e.altKey && editable) {
	// 		const erroredAssemblies = selectAssemblyListByQuoteId(quoteID)(store.getState()).filter((a) => a.msrp === 0);
	// 		const erroredAssemblySequenceIds = erroredAssemblies.map((a) => a.sequence_id);
	// 		dispatch(setAssembliesUnlocked({
	// 			quoteId: quoteID,
	// 			unlocked: true,
	// 			sequenceIds: erroredAssemblySequenceIds
	// 		}))
	// 		dispatch(repriceAssemblies({
	// 			quoteId: quoteID,
	// 			sequenceIds: assemblies
	// 		}));
	// 	}
	// };
	// useEffect(() => {
	// 	document.addEventListener('keydown', keydownHandler);
	// 	return () => {
	// 		document.removeEventListener('keydown', keydownHandler);
	// 	}
	// }, []);

	function closeAddShade() {
		setShowProductForm(false);

		document.body.classList.remove("editing");
	}

	// function unlockAndEditQuote() {
	// 	quote.unlock(false);
	// 	setShowingPricingLocked(false);
	// }

	// function generateInstallerCopy() { }

	const quoteType = useQuoteTypeNameByQuoteId(quoteID);
	const quote = useQuoteById(quoteID);
	const isAwningQuote = (quote?.product_category ?? 'roller_shades') === 'awnings';

	const invoice = (
		<InvoiceTable
			quoteId={quoteID}
			unlockBySequenceId={setShowEditQuoteDisclaimer}
			ROOT={ROOT}
		/>
	);

	if (loadFailed) {
		return (
			<div className="loading-spinner">
				Unable to load quote
				{' '}
				{quoteID}
				. Please refresh the page or try again later.
			</div>
		);
	}

	if (!isLoaded) {
		return (
			<div className="loading-spinner">
				Loading Quote...
			</div>
		);
	}

	return (
		<>
			{showingPopulateDashboardModal ? (
				<QuotePopulateDashboardTasks
					quoteId={quoteID}
					ROOT={props.ROOT}
					onClose={() => setShowingPopulateDashboardModal(false)}
				/>
			) : null}
			{
				showingQuoteReviews ? (
					<Popup
						modal
						overlayStyle={{ padding: "4em" }}
						contentStyle={{
							width: "100%",
							maxWidth: "75em",
							borderRadius: "var(--bs-border-radius)",
							padding: "1em 2em"
						}}
						open={showingQuoteReviews}
						onClose={() => setShowingQuoteReviews(false)}
					>
						<QuoteReviewTable
							quoteId={quoteID}
						/>
					</Popup>
				) : null
			}

			<div
				style={{ zIndex: 29 }}
				className={`local-bootstrap  no-print quote ${isEditable ? "" : "no-edit"}`}
			>
				{quoteStore?.order_status !== 'active_quote' && isEditable ? (
					<div id="pending-order-title">Pending Order</div>
				) : null}

				<div id="quote-head-wrapper">
					<div id="quote-options-holder">
						<Container fluid className="local-bootstrap">
							<Row>
								<Col>
									<QuoteFields
										quoteId={quoteID}
										ROOT={props.ROOT}
									/>
								</Col>

								{isPsAdmin ? (
									<Col
										xs={12}
										md={12}
										lg={2}
										className="text-end"
										style={{ marginTop: "1em" }}
									>
										<QuoteAdminBar
											quoteId={quoteID}
											showHistory={() =>
												setShowingHistoryModal(true)}
											showFabricAllowedIndoor={() => {
												// console.log("Allow Disc. Fabrics Indoor clicked");
												setShowingFabricAllowedIndoorModal(true);
											}}
											showFabricAllowedOutdoor={() => {
												// console.log("Allow Disc. Fabrics Outdoor clicked");
												setShowingFabricAllowedOutdoorModal(true);
											}}
											showCostBreakdown={() =>
												setShowingCostBreakdown(true)}
											showPopulateDashboardTasks={() =>
												setShowingPopulateDashboardTasks(true)}
											setIsAddingCOROutdoorShade={() => setShowAddCOROutdoorShade(true)}
											showQuoteReviews={() => setShowingQuoteReviews(true)}
											ROOT={props.ROOT}
										/>
									</Col>
								) : null}
							</Row>
						</Container>
					</div>
				</div>

				<QuoteActionsNew
					key={`${quoteID}quoteactionsnew`}
					setShowConfigurations={setShowConfigurations}
					showEditQuoteDisclaimer={showEditQuoteDisclaimer}
					setShowEditQuoteDisclaimer={setShowEditQuoteDisclaimer}
					ROOT={props.ROOT}
					quoteId={quoteID}
				/>

				<div style={{ zIndex: 20 }} id="invoice-entries">
					{invoice}
				</div>
				<div
					className="button-holder"
					style={{
						justifyContent: "center",
						display: "flex",
						marginTop: "0",
					}}
				>
					{!isEditable ? null : (
						<>
							<Popup
								open={showProductForm}
								className="mobile-modal no-additional-background "
								modal
								nested
								onClose={() => setShowProductForm(false)}
							>
								<div>
									<div id="product-editor">
										<div className="product-form">
											<ProductForm
												quoteType={quoteType}
												onCancel={closeAddShade}
												onAdd={closeAddShade}
												close={() => setShowProductForm(false)}
												openAddPsOutdoorShade={() => {
													setShowAddPSOutdoorShade(true);
													setShowProductForm(false);
												}}
												indoorFabrics={indoorFabrics}
												outdoorFabrics={psOutdoorFabrics}
												quoteId={quoteID}
											/>
										</div>
									</div>
								</div>
							</Popup>
							<Button
								onClick={() => setShowProductForm(true)}
								color={quoteType ?? 'green'}
								style={{
									fontSize: "17px",
									maxWidth: "unset",
									marginLeft: "20px",
								}}
							// icon="fas fa-plus"
							>
								<FontAwesomeIcon icon={faPlus} className="choice-icon" />
								{isAwningQuote ? " Awnings" : " Shade / Accessories"}
							</Button>
						</>
					)}
				</div>

				<Container className="local-bootstrap">
					<Row style={{ marginRight: "1em" }}>
						<Col xs={12} md={5} style={{ marginLeft: "1em" }}>
							<TextArea
								key={`notes-${quoteID}`}
								label="Special Requests for Production:"
								wrapperStyle={{ alignSelf: "center" }}
								style={{
									resize: "vertical",
									width: "80%",
									height: "10em",
								}}
								quoteId={quoteID}
								disabled={
									!isEditable
								}
								defaultValue={quoteStore?.notes || ""}
								onChange={(new_value) => {
									changeNotes(new_value);
								}}
								maxLength={20000}
							/>
						</Col>
						<Col
							xs={12}
							md={6}
							style={{ marginTop: "1em" }}
						>
							{needsVerification ? (
								<QuoteVerifications
									quoteType={quoteType}
									setShowConfigurations={setShowConfigurations}
									showConfigurations={showConfigurations}
									editable={editable}
									setShowEditQuoteDisclaimer={
										setShowEditQuoteDisclaimer
									}
									quoteId={quoteID}
								/>
							) : (
								<TotalPrice
									key={`totals-${quoteID}`}
									quoteId={quoteID}
									className="total-price"
								/>
							)}
						</Col>
					</Row>
				</Container>
				<AddPSOutdoorShadeModel
					quoteId={quoteID}
					onClose={() => setShowAddPSOutdoorShade(false)}
					isOpen={showAddPSOutdoorShade}
				/>
				<AddCOROutdoorShadeModal
					quoteId={quoteID}
					onClose={() => setShowAddCOROutdoorShade(false)}
					isOpen={showAddCOROutdoorShade}

				/>

				{showingApproveModal ? (
					<div>
						<ConfirmApproval
							quoteId={quoteID}
							preLoadedQuote
							onComplete={props.ROOT.refreshContent}
							close={() => setShowingApproveModal(false)}
						/>
					</div>
				) : null}
			</div>

			<Popup
				modal
				open={showingPlaceOrder}
				closeOnDocumentClick
				onClose={() => setShowingPlaceOrder(false)}
				className="mobile-modal"
			>
				<PlaceOrder
					quoteId={quoteID}
					ROOT={props.ROOT}
					done={props.ROOT.refreshContent}
					close={() => setShowingPlaceOrder(false)}
				/>
			</Popup>

			{showForceEditModal ? (
				<ForceEditModal
					quoteId={quoteID}
					close={() => setShowForceEditModal(false)}
				/>
			) : null}
			{/*
			<PrintQuoteNew
				quoteId={quote}
				newQuote={newQuote}
				isPrint
				currencyData={userCurrencyData}
			/> */}

			{quoteLockedUser !== null ? (
				<QuoteLockedModal
					viewingUser={quoteLockedUser}
					quoteID={quoteID}
					readOnlyMode={() => {
						loadQuoteWithID();
						setQuoteLockedUser(null);
					}}
					cancel={() => props.ROOT.loadContent("#Home")}
				/>
			) : null}

			{showingHistoryModal && isPsAdmin ? (
				<QuoteHistoryModal
					quoteId={quoteID}
					onClose={() => setShowingHistoryModal(false)}
				/>
			) : null}

			{ShowingFabricAllowedIndoorModal && isPsAdmin ? (
				// console.log("FabricAllowedModal Indoor is rendering"),
				<FabricAllowedModalIndoor
					quoteId={quoteID}
					onClose={() => setShowingFabricAllowedIndoorModal(false)}
				/>
			) : null}

			{ShowingFabricAllowedOutdoorModal && isPsAdmin ? (
				// console.log("FabricAllowedModal Outdoor is rendering"),
				<FabricAllowedModalOutdoor
					quote={quoteID}
					onClose={() => setShowingFabricAllowedOutdoorModal(false)}
				/>
			) : null}

			{showingPopulateDashboardTasks && isPsAdmin ? (
				<PopulateDashboardTasks
					onClose={() => setShowingPopulateDashboardTasks(false)}
					quoteId={quoteID}
					ROOT={props.ROOT}
				/>
			) : null}

			{showingCostBreakdown && isPsAdmin ? (
				<CostBreakownModal
					onClose={() => setShowingCostBreakdown(false)}
					quoteId={quoteID}
				/>
			) : null}

			{costBreakdownShade && isPsAdmin ? (
				<ShadeCostBreakdown
					shade={costBreakdownShade}
					onClose={() => setCostBreakdownShade(null)}
					quoteId={quoteID}
				/>
			) : null}

		</>
	);
};

export default Quote;
